import { Link } from 'react-router-dom';
import './carousel_card.css';

function CarouselCard({ post }) {
    return (
        <Link to={`/blog/${post.slug}`} className="carousel-card">
            <img src={post.imageUrl} alt={post.title} className="carousel-image" />
            <div className="carousel-content">
                <h3 className="carousel-title">{post.title}</h3>
                <p className="carousel-desc">{post.description || post.subtitle || ''}</p>
            </div>
        </Link>
    );
};

export default CarouselCard;
